import babyRouterMap from '@/router/modules/baby'

const healthbookRouterMap = [
  {
    name: "月经周期与基础体温自测记录",
    path: "/healthbook/menstrualrecords",
    component: () => import("@/pages/healthbook/menstrualrecords")
  },
  {
    name: "新增自测记录",
    path: "/healthbook/addmenstrual",
    component: () => import("@/pages/healthbook/addmenstrual")
  },
  {
    name: "备孕爸妈自我记录",
    path: "/healthbook/pregnantselfrecords",
    component: () => import("@/pages/healthbook/pregnantselfrecords")
  },
  {
    name: "甜蜜时刻",
    path: "/healthbook/sweetmoment",
    component: () => import("@/pages/healthbook/sweetmoment")
  }, 
  {
    name: "准妈妈的基本情况",
    path: "/healthbook/mothersinfo",
    component: () => import("@/pages/healthbook/mothersinfo")
  },
  {
    name: "家庭树",
    path: "/healthbook/familytree",
    component: () => import("@/pages/healthbook/familytree")
  },
  {
    name: "爸爸寄语",
    path: "/healthbook/message",
    component: () => import("@/pages/healthbook/message")
  },
  {
    name: "妈妈寄语",
    path: "/healthbook/message",
    component: () => import("@/pages/healthbook/message")
  }, 
  {
    name: "孕1~3月自我记录",
    path: "/healthbook/earlyPregnancyRecord",
    component: () => import("@/pages/healthbook/earlyPregnancyRecord")
  },
  {
    name: "孕4~7月自我记录",
    path: "/healthbook/midPregnancyRecord",
    component: () => import("@/pages/healthbook/midPregnancyRecord")
  },
  {
    name: "孕8~10月自我记录",
    path: "/healthbook/advancedPregnancyRecord",
    component: () => import("@/pages/healthbook/advancedPregnancyRecord")
  },
  {
    name: "分娩情况自我记录",
    path: "/healthbook/deliverySelfRecord",
    component: () => import("@/pages/healthbook/deliverySelfRecord")
  },
  {
    name: "产褥期情况自我记录",
    path: "/healthbook/puerperalSelfRecord",
    component: () => import("@/pages/healthbook/puerperalSelfRecord")
  },
  {
    name: "宝宝出生记录",
    path: "/healthbook/babyBirthRecord",
    component: () => import("@/pages/healthbook/babyBirthRecord")
  },
  {
    name: "育儿记录列表",
    path: "/healthbook/parentingRecords/list",
    component: () => import("@/pages/healthbook/parentingRecordslist")
  },
  {
    name: "新生儿早期育儿记录",
    path: "/healthbook/parentingRecords/0",
    component: () => import("@/pages/healthbook/parentingRecords0")
  },
  {
    name: "1个月育儿记录",
    path: "/healthbook/parentingRecords/1",
    component: () => import("@/pages/healthbook/parentingRecords1")
  },
  {
    name: "3个月育儿记录",
    path: "/healthbook/parentingRecords/3",
    component: () => import("@/pages/healthbook/parentingRecords3")
  },
  {
    name: "6个月育儿记录",
    path: "/healthbook/parentingRecords/6",
    component: () => import("@/pages/healthbook/parentingRecords6")
  },
  {
    name: "8个月育儿记录",
    path: "/healthbook/parentingRecords/8",
    component: () => import("@/pages/healthbook/parentingRecords8")
  },
  {
    name: "1岁育儿记录",
    path: "/healthbook/parentingRecords/12",
    component: () => import("@/pages/healthbook/parentingRecords12")
  },  
  {
    name: "1岁6个月育儿记录",
    path: "/healthbook/parentingRecords/18",
    component: () => import("@/pages/healthbook/parentingRecords18")
  },
  {
    name: "2岁育儿记录",
    path: "/healthbook/parentingRecords/24",
    component: () => import("@/pages/healthbook/parentingRecords24")
  },
  {
    name: "2岁6个月育儿记录",
    path: "/healthbook/parentingRecords/30",
    component: () => import("@/pages/healthbook/parentingRecords30")
  },
  {
    name: "3岁育儿记录",
    path: "/healthbook/parentingRecords/36",
    component: () => import("@/pages/healthbook/parentingRecords36")
  },
  {
    name: "4岁育儿记录",
    path: "/healthbook/parentingRecords/48",
    component: () => import("@/pages/healthbook/parentingRecords48")
  },
  {
    name: "5岁育儿记录",
    path: "/healthbook/parentingRecords/60",
    component: () => import("@/pages/healthbook/parentingRecords60")
  },
  {
    name: "6岁育儿记录",
    path: "/healthbook/parentingRecords/72",
    component: () => import("@/pages/healthbook/parentingRecords72")
  },
];
export default healthbookRouterMap;
